module.exports = __webpack_public_path__ + "static/media/about-one.3dcdab07.png";